import React from 'react'
import App from './App.js'
import './styles/tailwind.css';
import { Provider } from 'react-redux';
import { store } from './store/index.jsx';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';

const container = document.getElementById('root');

const app = (
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);

// If react-snap has pre-rendered the page, hydrate instead of render
if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}